// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\"> <g fill=\"none\" fill-rule=\"evenodd\"> <path fill=\"#E6475A\" d=\"M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0\"/> <path fill=\"#FFF\" d=\"M9.081 6.656H2.92a.656.656 0 0 1 0-1.312H9.08a.656.656 0 0 1 0 1.312\"/> </g> </svg> ";
// Exports
module.exports = code;